$.fn.digits = function(){
    return this.each(function(){
        var value = $(this).val().toString();
        value = value.replace(/,/g, '');
        $(this).val( value.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    });
};


var calculator = (function(){
    $(document).ready(function() {

        this.step = 1;
        this.revenue = 0;
        var _this = this;


        $('#sales').keypress(function(event) {
            var value = $("#sales").val();
            if (event.which < 48 || event.which > 57) {
                event.preventDefault();
            }
            if (value === '0') {
                if (event.which === 48) {
                    event.preventDefault();
                } else {
                    $("#sales").val('');
                }
            }
            if (event.which === 13) {
                _this.revenue = value;
                submitRevenue();
            }
        });

        $('#sales').on('input', function(){
            $('#sales').digits();
        });

        $('.error, .screen').on('click', function(){
            $('.error').hide();
            $('.screen').hide();
            $('#sales').focus();
        });

        $(window).resize(function(){
            if (_this.step === 1) {
                easeFooterHeight($('.step1'));
            } else {
                easeFooterHeight($('.step2'));
            }
        });

        setTimeout(function(){
            $('.carousel-icons').addClass('animated-footer');
        },400);
        setTimeout(function(){
            easeFooterHeight($('.step1'));
        },50);
        var upsells = false;
        $('.step1 .big-input').on('focus', function() {
            $('.step1 .input-border').css({
                'background-color' : '#ECF1F5',
                'border-color' : '#ECF1F5'
            });
        });
        $('.step1 .big-input').on('blur', function() {
            $('.step1 .input-border').css({
                'background-color' : '#fff',
                'border-color' : '#fff'
            });
        });
        $('.step1 .large-button').on('click', function() {
            if (submitRevenue()) {
                var value = $("#sales").val();
                _this.revenue = value;
                _this.step = 2;
            }
        });
        $('.step2 .email-input').on('focus', function(){
            $('.step2 .input-border').css({
                'background-color' : '#7CBFF3',
                'border-color' : '#7CBFF3'
            });
        });
        $('.step2 .email-input').on('blur', function(){
            $('.step2 .input-border').css({
                'background-color' : '#1D96F3',
                'border-color' : '#1D96F3'
            });
        });
        $('.step2 .large-button').on('click', function() {
            submitEmail(_this.revenue);
        });
        $("#email").on('keypress', function(event) {
            if (event.which === 13) {
                submitEmail(_this.revenue);
            }
        });
    });

    var submitRevenue = function() {
        var revenue = $('.big-input').val();
        if (revenue === '') {
            return false;
        } else {
            if (revenue <= 0) {
                $('.screen').show();
                positionError();
                return false;
            } else {
                stepTwoTransition(revenue);
                return true;
            }
        }
    };

    var submitEmail = function(revenue) {
        var email = $('#email').val();
        if (!email.match(/.+@.+\..+/g)) {
            $('.step2 .input-border').css({
                'background-color' : '#FFBABA',
                'border' : '1px solid #FFBABA'
            });
            $('.step2 .email-input').css({
                'border' : '1px solid #ff3b46'
            });
        } else {
            postEmail(email, revenue);
            stepThreeTransition();
        }
    };

    var positionError = function() {
        var viewport_width = $( window ).width();
        var position = $("#sales").offset();
        var width = $(".sales-input-class").width();
        var height = $(".sales-input-class").height();

        if (viewport_width > 500) {
            var el_height = $('.side-error').outerHeight();
            var el_width = $('.side-error').outerWidth();
            var left = (position.left + width + 10) + 'px';
            var top = (position.top - ((el_height - height) / 2)) + 'px';
            $('.side-error').css({
                'top' : top,
                'left' : left
            });
            $('.side-error').show();
        } else {
            var el_height = $('.bottom-error').outerHeight();
            var el_width = $('.bottom-error').outerWidth();
            var left = (position.left + ((width - el_width) / 2)) + 'px';
            var top = (position.top + 66) + 'px';
            $('.bottom-error').css({
                'top' : top,
                'left' : left
            });
            $('.bottom-error').show();
        }
    };

    var stepTwoTransition = function(revenue) {
        $('.step1').addClass('animated bounceOutLeft');
        $('.step1').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
            $('.step1').hide();
        });
        carouselUpdate(2);
        $('.step2 .money.amount').html('$' + revenue + '/mo');
        revenue = stripCommas(revenue);
        rawRevenue = revenue;
        var upsellsRevenue = Math.ceil(0.68 * revenue);
        var priceRevenue = Math.ceil(0.19 * revenue);
        var checkoutRevenue = Math.ceil(1.68 * revenue);
        var finalRevenue = revenue + upsellsRevenue + priceRevenue + checkoutRevenue;
        var rawFinalRevenue = finalRevenue;
        revenue = moneyFormat(revenue);
        finalRevenue = moneyFormat(finalRevenue);
        $('.item-container .upsell-amount').html('+ $0/mo');
        $('.item-container .price-amount').html('+ $0/mo');
        $('.item-container .checkout-amount').html('+ $0/mo');
        $('.ledger-container .total-amount').html(revenue);
        setTimeout(function(){
            $('.step2').show();
            $('.step2').addClass('animated bounceInRight');
            easeFooterHeight($('.step2'));
        }, 200);

        setTimeout(function(){
            startRevenueTicker(rawRevenue, rawFinalRevenue);
            itemAnimation(upsellsRevenue, priceRevenue, checkoutRevenue);
        }, 1200);
    };

    var stepThreeTransition = function() {
        $('.step2').addClass('animated bounceOutLeft');
        $('.step2').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
            $('.step2').hide();
        });
        carouselUpdate(3);
        setTimeout(function(){
            $('.step3').show();
            $('.step3').addClass('animated bounceInRight');
            easeFooterHeight($('.step3'));
        }, 200);
    };

    var carouselUpdate = function(step) {
        $('.carousel-icons').children('svg').each(function(index, svg) {
            if ((index + 1) === step) {
                $(svg).children('use').attr('xlink:href', '#carousel-filled');
            } else {
                $(svg).children('use').attr('xlink:href', '#carousel-empty');
            }
        });
    };

    var easeFooterHeight = function(element) {
        var height = element.height();
        var viewport_width = $( window ).width();
        if (viewport_width <= 500) {
            height = height + 34 + 'px';
        } else {
            height = height + 59 + 'px';
        }

        $('.carousel-icons').css({'margin-top':height});
    };

    var stripCommas = function(value) {
        value = value.replace(/,/g, '');
        return parseInt(value);
    };

    var addCommas = function(value) {
        value = value.toString();
        value = value.replace(/,/g, '');
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    var moneyFormat = function(value) {
        value = addCommas(value);
        return '$' + value;
    };

    var itemAnimation = function(amountOne, amountTwo, amountThree) {
        $('.item-container.one').addClass('active');
        startItemRevenueTicker($('.item-container.one .money'), 0, amountOne);
        setTimeout(function(){
            $('.item-container.two').addClass('active');
            startItemRevenueTicker($('.item-container.two .money'), 0, amountTwo);
        }, 1600);
        setTimeout(function(){
            $('.item-container.three').addClass('active');
            startItemRevenueTicker($('.item-container.three .money'), 0, amountThree);
        }, 3200);
    };

    var startRevenueTicker = function(start, finish) {
        var ticks = 285;
        var length = 16;
        updateRevenue($('.ledger-container .total-amount'), length, 0, ticks, start, finish, false);
    };

    var startItemRevenueTicker = function(element, start, finish) {
        var ticks = 100;
        var length = 16;
        updateRevenue(element, length, 0, ticks, start, finish, true);
    };

    var updateRevenue = function(element, length, tick, maxTicks, start, finish, plus) {
        var nextTick = tick + 1;
        var increment = (finish - start) / maxTicks;
        var newValue = Math.ceil((increment * nextTick) + start);
        newValue = moneyFormat(newValue);
        if (plus) {
            element.html('+ ' + newValue + '/mo');
        } else {
            element.html(newValue);
        }

        setTimeout(function() {
            if (tick < maxTicks) {
                updateRevenue(element, length, nextTick, maxTicks, start, finish, plus);
            }
        }, length);
    };

    var postEmail = function(email, revenue) {
        revenue = stripCommas(revenue);
        $.post('/calculator', {'email' : email, 'revenue' : revenue});
        fbq('track', "Lead");
    };

})();
